namespace Serenity {
    export interface OperationStatusRequest extends Serenity.ServiceRequest {
        OperationGuid?: string;
    }
}
